const countryCodes =
    [
        {
            "country": "India",
            "code": "+91",
            "flag": "IN"
        },
        {
            "country": "Afghanistan",
            "code": "+93",
            "flag": "AF"
        },
        {
            "country": "Albania",
            "code": "+355",
            "flag": "AL"
        },
        {
            "country": "Algeria",
            "code": "+213",
            "flag": "DZ"
        },
        {
            "country": "Andorra",
            "code": "+376",
            "flag": "AD"
        },
        {
            "country": "Angola",
            "code": "+244",
            "flag": "AO"
        },
        {
            "country": "Argentina",
            "code": "+54",
            "flag": "AR"
        },
        {
            "country": "Australia",
            "code": "+61",
            "flag": "AU"
        },
        {
            "country": "Austria",
            "code": "+43",
            "flag": "AT"
        },
        {
            "country": "Bahrain",
            "code": "+973",
            "flag": "BH"
        },
        {
            "country": "Bangladesh",
            "code": "+880",
            "flag": "BD"
        },
        {
            "country": "Belgium",
            "code": "+32",
            "flag": "BE"
        },
        {
            "country": "Brazil",
            "code": "+55",
            "flag": "BR"
        },
        {
            "country": "China",
            "code": "+86",
            "flag": "CN"
        },
        {
            "country": "Denmark",
            "code": "+45",
            "flag": "DK"
        },
        {
            "country": "Egypt",
            "code": "+20",
            "flag": "EG"
        },
        {
            "country": "France",
            "code": "+33",
            "flag": "FR"
        },
        {
            "country": "Germany",
            "code": "+49",
            "flag": "DE"
        },
        {
            "country": "Indonesia",
            "code": "+62",
            "flag": "ID"
        },
        {
            "country": "Italy",
            "code": "+39",
            "flag": "IT"
        },
        {
            "country": "Japan",
            "code": "+81",
            "flag": "JP"
        },
        {
            "country": "Kuwait",
            "code": "+965",
            "flag": "KW"
        },
        {
            "country": "Malaysia",
            "code": "+60",
            "flag": "MY"
        },
        {
            "country": "Mexico",
            "code": "+52",
            "flag": "MX"
        },
        {
            "country": "Netherlands",
            "code": "+31",
            "flag": "NL"
        },
        {
            "country": "New Zealand",
            "code": "+64",
            "flag": "NZ"
        },
        {
            "country": "Oman",
            "code": "+968",
            "flag": "OM"
        },
        {
            "country": "Pakistan",
            "code": "+92",
            "flag": "PK"
        },
        {
            "country": "Qatar",
            "code": "+974",
            "flag": "QA"
        },
        {
            "country": "Russia",
            "code": "+7",
            "flag": "RU"
        },
        {
            "country": "Saudi Arabia",
            "code": "+966",
            "flag": "SA"
        },
        {
            "country": "South Africa",
            "code": "+27",
            "flag": "ZA"
        },
        {
            "country": "Spain",
            "code": "+34",
            "flag": "ES"
        },
        {
            "country": "Sweden",
            "code": "+46",
            "flag": "SE"
        },
        {
            "country": "Switzerland",
            "code": "+41",
            "flag": "CH"
        },
        {
            "country": "United Arab Emirates",
            "code": "+971",
            "flag": "AE"
        },
        {
            "country": "United Kingdom",
            "code": "+44",
            "flag": "GB"
        },
        {
            "country": "United States / CN",
            "code": "+1",
            "flag": "US"
        }
    ]

export default countryCodes